var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');

var addUserModal = Object.assign(Object.create(Model), require('../../../../../models/users/user'));
addUserModal.fields = Object.assign({}, addUserModal.fields);
delete addUserModal.fields.username;

function normalizeErrors(errors) {
  if (Array.isArray(errors)) return errors;
  if (typeof errors === 'object' && errors.error && typeof errors.error === 'string') return [errors.error];
  if (typeof errors === 'string') return [errors];
  return ['Unable to add user'];
}

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


addUserModal.editDialogue = function (record, options) {
  Model.initForm.call(addUserModal, record)
  addUserModal.groupRecord = options.groupRecord;

  var submit = function () {
    var formData = {};
    addUserModal.errors = [];
    addUserModal.validate(addUserModal.form)
    .then(res=>{
      Object.keys(addUserModal.fields).forEach(function (key) {
        if (key == 'in' || key == 'out') {
          if (addUserModal.form[key]() && addUserModal.form[key]['@rid']) {
            return formData[key] = addUserModal.form[key]()['@rid'];
          }
        }
        formData[key] = addUserModal.form[key].toJSON();
      })
      return loaders.requestWithLoader({
        url: `/api/v1/useringroup/${addUserModal.groupRecord['@rid'].slice(1)}`,
        method: "POST",
        body: formData,
      })
    })
    .then( response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(e=>{
      addUserModal.errors = normalizeErrors(e);
      m.redraw();
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title( 'Add User: ')
  modal.vm.body = addUserModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  
  modal.vm.open();
}


addUserModal.view = function () {
  return m('form', {role:'form'}, [
    addUserModal.errorView(),
    m('label', 'First Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addUserModal.form.firstName(ev.target.value),
      value: addUserModal.form.firstName(),
    }),
    m('label', 'Last Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addUserModal.form.lastName(ev.target.value),
      value: addUserModal.form.lastName(),
    }),
    m('label', 'Email:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addUserModal.form.email(ev.target.value),
      value: addUserModal.form.email(),
    }),
    m('label', 'Sms:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addUserModal.form.sms(ev.target.value),
      value: addUserModal.form.sms(),
    }),
  ])
}

module.exports = addUserModal;
